import React, { PropTypes } from 'react';
import ContactAddressNewForm from './ContactAddressNewForm';
import ContactAddressList from './ContactAddressList';

class ContactAddress extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         showForm: false
      };
   }

   toggleShowForm = () => {
      this.setState({
         showForm: !this.state.showForm
      });
   };

   render() {
      const { showForm } = this.state;
      const { contactId } = this.props.params;
      return (
         <div>
            {showForm === false && <ContactAddressList contactId={contactId} toggleShowForm={this.toggleShowForm} />}
            {showForm === true && <ContactAddressNewForm contactId={contactId} toggleShowForm={this.toggleShowForm} />}
         </div>
      );
   }
}

ContactAddress.propTypes = {
   params: PropTypes.object
};

export default ContactAddress;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactAddress.js
 **/